import { datiTitolareBenefVitaEff } from './sezioni/sezioniAnagraficaTitolareEffBenefVita';

export const titolareEffBenefVita = {
  anagraficaValida: null,
  controlloDati: '',  
  datiTitolareBenefVitaEff: datiTitolareBenefVitaEff,
};